import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import Typography from '@src/new-components/Typography';
import Dot from '@src/new-components/Dot/Index';
import { COLOR } from '@src/styles/color';
import { VOICE_ITEM_VARIANT } from '@src/constants/voiceLibrary';
import { VoiceDescriptionContainer } from './index.style';

const VoiceDescription = ({ category, gender, ageGroup, variant }) => {
  const { t } = useTranslation();

  return (
    <VoiceDescriptionContainer>
      {(category?.name || category) && (
        <Typography variant="body-14-regular" color={COLOR.label2[64]}>
          {t(category?.name) || t(category)}
        </Typography>
      )}
      {variant === VOICE_ITEM_VARIANT.LIST && (
        <>
          {(category?.name || category) && (
            <Box className="dot-container">
              <Dot size={4} color={COLOR.borderDropdown} />
            </Box>
          )}
          <Typography variant="body-14-regular" color={COLOR.label2[64]}>
            {t(gender)}
          </Typography>
          {ageGroup && (
            <>
              <Box className="dot-container">
                <Dot size={4} color={COLOR.borderDropdown} />
              </Box>
              <Typography variant="body-14-regular" color={COLOR.label2[64]}>
                {t(ageGroup)}
              </Typography>
            </>
          )}
        </>
      )}
    </VoiceDescriptionContainer>
  );
};

export default VoiceDescription;
